<div class="gateDetails">
  @if (timeoutInfo()) {
    <div class="widget">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingInfo()) {
    <div class="widget flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else if (gateSystem) {
    <div class="widget flex justify-content-between p-3 align-items-center">
      <div class="flex flex-column gap-1">
        <span class="greyText font-size-sm">{{ "gate_administration.asset_types.gate_system" | translate }}</span>
        <span>{{ gateSystem.label }}</span>
      </div>
      <div class="flex flex-column gap-1">
        <span class="greyText font-size-sm">{{ "gate_administration.asset_details_card.coreId" | translate }}</span>
        <span>{{ gateSystem.coreId }}</span>
      </div>
      <div class="flex gap-2">
        <app-svg-icon
          *appHasPermission="{
            permissions: [permissions.allPermissions.ASSET_COMPONENT_READ],
          }"
          id="listButton"
          class="pointer"
          iconName="list"
          iconColor="primary"
          (click)="onListClick()"
        >
        </app-svg-icon>

        <app-svg-icon
          *appHasPermission="{
            permissions: [
              permissions.allPermissions.ASSET_MASTER_DATA_UPDATE,
              permissions.allPermissions.ASSET_DYNAMIC_DATA_UPDATE,
            ],
          }"
          id="editButton"
          (click)="onEditClick()"
          class="pointer"
          iconName="edit"
          iconColor="primary"
        ></app-svg-icon>

        <app-svg-icon
          *appHasPermission="{
            permissions: [permissions.allPermissions.HARDWARE_CONFIG_READ],
          }"
          id="hardwareConfigurationButton"
          class="pointer"
          iconName="cog"
          iconColor="primary"
          (click)="onHardwareConfigurationClick()"
        />
      </div>
    </div>
  }

  @if (timeoutMedia()) {
    <div class="widget">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingMedia()) {
    <div class="widget h-full flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <ngx-simplebar class="flex flex-column widget p-4" [options]="{ autoHide: false }">
      <div class="mb-4">
        <div class="flex justify-content-between mb-4 align-items-end">
          <span class="list-title">
            {{ "gate_administration.gate_details.images_title" | translate }}
          </span>
          <app-svg-icon
            id="openFileDialogButton"
            iconName="plus"
            iconColor="primary"
            (click)="openFileDialog()"
          ></app-svg-icon>
        </div>
        <div class="imageList">
          @for (image of images; track image) {
            <app-image-list-item
              (openEvent)="openImage(image)"
              (editEvent)="openFileDialog(image)"
              (deleteEvent)="deleteImage($event, image)"
              [config]="image"
            >
            </app-image-list-item>
          } @empty {
            <span class="font-italic"> {{ "gate_administration.gate_details.no_images" | translate }}</span>
          }
        </div>
      </div>
      <div
        *appHasPermission="{
          permissions: [permissions.allPermissions.INSPECTION_REPORT_READ],
        }"
      >
        <div class="flex justify-content-start align-items-center gap-2 mb-4">
          <span class="list-title">
            {{ "protocols.protocols_title" | translate }}
          </span>
          <app-svg-icon
            iconName="info-circle"
            tooltipPosition="bottom"
            [pTooltip]="translate.instant('protocols.hint')"
            iconColor="primary"
            class="flex"
          >
          </app-svg-icon>
        </div>
        <div class="protocolsList">
          @for (protocol of protocols(); track protocol.id) {
            <app-document-list-item [config]="protocol"></app-document-list-item>
          } @empty {
            <span class="font-italic"> {{ "protocols.no_protocols" | translate }}</span>
          }
        </div>
      </div>
    </ngx-simplebar>
  }
</div>
